import { Component, OnInit } from '@angular/core';
import { SubAreaModel } from '../../../models/subarea.model';
import { BusquedasService } from '../../../services/busquedas.service';
import { SubAreaService } from '../../../services/subarea.service';
import { ModalImagenService } from '../../../services/modal-imagen.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-subareas',
    templateUrl: './subareas.component.html',
    styleUrls: ['./subareas.component.css'],
    standalone: false
})
export class SubareasComponent implements OnInit {

public subareas: SubAreaModel[] = [];
public subareasTemp: SubAreaModel[] = [];
public cargando: boolean = true;

page = 1;
pageSize = 10;
collectionSize = 0;
maxSize = 0;

  constructor(  private subareasService: SubAreaService,
                private busquedasService: BusquedasService,
                private modalImagenService: ModalImagenService) { }

  ngOnInit(): void {
    this.cargarSubAreas();
  }







cargarSubAreas() {


  this.cargando = true;

  this.subareasService.cargarSubAreas()
                      .subscribe( subareas => {


                        this.cargando = false;

                        this.subareas = subareas;
                        this.subareasTemp = subareas;
                        this.maxSize = Math.ceil(this.subareasTemp.length / this.pageSize);
                        this.collectionSize = this.subareasTemp.length;

                      });


}



guardarCambios( subarea: SubAreaModel ) {

  this.subareasService.actualizarSubArea( subarea._id, subarea.name )
                      .subscribe( resp => {

                        Swal.fire(
                          'Updated',
                          subarea.name,
                          'success'
                        );
                      });

}



buscar( termino: string ) {

  if ( termino.length === 0 ){
    return this.subareas = this.subareasTemp;
  }




  this.busquedasService.buscar( 'subareas', termino )
                      .subscribe( (resp: any) => {

                        this.subareas = resp;
                      });

}



borrarSubArea( subarea: SubAreaModel ) {

  this.subareasService.borrarSubArea( subarea._id )
                      .subscribe( resp => {


                        this.cargarSubAreas();

                        Swal.fire(
                          'Delected',
                          subarea.name,
                          'success'
                        );
                      });




}


async abrirSweetAlert() {
   const { value = '' } = await Swal.fire<string>({
     title: 'New SubArea',
     text: 'Name SubArea',
     input: 'text',
     inputPlaceholder: 'Name',
     showCancelButton: true
   });



   if ( value.trim().length > 0 ) {

     this.subareasService.crearSubArea( value )
                         .subscribe( (resp: any) => {

                           this.subareas.push(resp.subarea);
                         }, (err) => {
                          console.warn( err.error );
                          Swal.fire('Error', err.error.msg, 'error');
                        });

     }

 }


refresData() {
  this.subareas = this.subareasTemp.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
}

/**
 * Row-image preview (mirrors the equivalent in areas.component.ts).
 * Was a Phase-2 phantom click handler; now re-implemented.
 */
abrirModal( subarea: SubAreaModel ) {
  this.modalImagenService.abrirModal( 'subareas', subarea._id, subarea.img );
}

}
